import React, { CSSProperties } from "react";
import * as styles from "./velavu-notice.module.scss";
import { classArr } from "../../helper/style-helper";
import { StyleableIcon } from "../../helper/icon-helper";

export type VelavuNoticeType = "info" | "confirm" | "warning" | "error";

export interface VelavuNoticeProps {
	className?: string;
	style?: CSSProperties;
	type: VelavuNoticeType;
	icon?: StyleableIcon;
	children?: React.ReactNode;
}

export default function VelavuNotice(props: VelavuNoticeProps) {
	let style: string;
	switch (props.type) {
		case "info":
			style = styles.containerInfo;
			break;
		case "confirm":
			style = styles.containerConfirm;
			break;
		case "error":
			style = styles.containerError;
			break;
		case "warning":
			style = styles.containerWarning;
			break;
	}

	return (
		<div
			style={props.style}
			className={classArr(styles.container, style, props.className)}
		>
			{props.icon?.(24, "currentColor", styles.icon)}
			<div className={styles.containerText}>{props.children}</div>
		</div>
	);
}
